module.exports = __webpack_public_path__ + "img/BlinkArt_Sword9_Blue.e4de0ffc.png";